import { useHistory, useLocation } from "react-router-dom";
import useQuery from "utils/hooks/useQuery";
import { useRefValue } from "utils/hooks/misc.tsx";
import { useCallback } from "react";

const useHistoryWithQuery = () => {
  const location = useLocation();
  const locationRef = useRefValue(location);
  const query = useQuery();
  const queryRef = useRefValue(query);
  const history = useHistory();

  const appendQuery = (
    queryToAppend?: string | Record<string, string>,
    queryKeysToDelete?: string[],
    replace: boolean = true
  ) => {
    const updatedPath = getUpdatedPath(queryToAppend, queryKeysToDelete);
    replace ? history.replace(updatedPath) : history.push(updatedPath);
  };

  const getUpdatedPath = useCallback(
    (
      queryToAppend?: string | Record<string, string>,
      queryKeysToDelete?: string[],
      nextLocation?: string
    ) => {
      const updatedQuery = new URLSearchParams(queryRef.current.toString());
      const parsedQueryToAppend =
        typeof queryToAppend === "string"
          ? Object.fromEntries(new URLSearchParams(queryToAppend))
          : queryToAppend;
      for (const [key, value] of Object.entries(parsedQueryToAppend || {})) {
        updatedQuery.set(key, value);
      }
      queryKeysToDelete?.forEach((queryKey) => updatedQuery.delete(queryKey));
      return (
        (nextLocation ?? locationRef.current.pathname) +
        `?${updatedQuery.toString()}`
      );
    },
    []
  );

  const historyPush = (path: string) => {
    history.push(path + `?${query.toString()}`);
  };

  const historyReplace = (path: string) => {
    history.replace(path + `?${query.toString()}`);
  };

  return {
    appendQuery,
    historyPush,
    historyReplace,
    getUpdatedPath,
  };
};

export default useHistoryWithQuery;
